import React, { useEffect, lazy, Suspense } from 'react';
import clevertap from 'clevertap-web-sdk';
import { Redirect, Route, Switch } from 'react-router';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Loadboard from './Loads/Loadboard';
// import Error404 from './Pages/404';
// import Login from './Auth/Login';
// import Register from './Auth/Register';
// import ForgotPasswordPage from './Auth/ForgotPassword';
// import OwnerOperator from './Users/OwnerOperator';
// import Driver from './Users/Driver';
// import Company from './Users/Company';
// import Admin from './Users/Admin';
// import LoadsTracking from './Loads/LoadsTracking';
// import PublicLoadTracking from './Public/PublicLoadTracking';
// import DocumentsUploaded from './Loads/DocumentsUploaded';
// import Onboarding from './Users/Onboarding';
import Dashboard from './Dashboard';

// import TripSchedular from './Loads/TripSchedular';
// import Workbook from './Loads/Workbook';
// import Roles from './Users/Roles';
import PermissionDenied from 'components/common/PermissionDenied';
// import PublicZipCodeParsing from './Public/PublicZipCodeParsing';
// import MyOwnerOperators from './Dashboard/MyOwnerOperators';
// import UserInterests from './Loads/UserInterests';
// import TripInterests from './Loads/TripInterests';
// import Requests from './Workbook/Requests';
// import Bookings from './Workbook/Bookings';
// import TBOwnerOperators from './FleetManagement/TBOwnerOperators';

// import RealTimeTracking from './Loads/RealTimeTracking';
// import PublicRealTimeLoadTracking from './Public/PublicRealTimeLoadTracking';
// import LoadsDetailView from './Loads/RealTimeTracking/LoadsDetailView';
// import PublicLoadTrackingDetailView from './Public/PublicLoadTrackingDetailView';
// import Lanes from './Loads/Lanes';
// import RealTimeTrackingV2 from './Loads/RealTimeTrackingV2';
// import LoadDetailView from './Loads/RealTimeTrackingV2/LoadDetailView';
// import PublicLoadTrackingDetailViewV2 from './Public/PublicLoadTrackingDetailViewV2';
// import CarriersListingView from './CarrierNetworkIntelligence/CarriersListingView';
// import LoadsListView from './Loads/LoadsDocumentV2/LoadsListView';

import PageLoader from '../@jumbo/components/PageComponents/PageLoader';
import { AdminRoles } from '@jumbo/constants/AppConstants';

const RestrictedRoute = ({ component: Component, ...rest }) => {
  const { authUser } = useSelector(({ auth }) => auth);
  const permissions = authUser && authUser.info && authUser.info.admin_permissions;
  let access = rest.access;
  access = access && access.split('.');

  useEffect(() => {
    if (!authUser) return;
    //these populate demographic information in the clevertap
    clevertap.onUserLogin.push({
      Site: {
        Name: authUser?.info?.name,
        Identity: authUser?.info?.id,
        Email: authUser?.info?.email,
        Phone: authUser?.info?.phone,
      },
    });
  }, [authUser]);

  return (
    <Route
      {...rest}
      render={props =>
        authUser ? (
          (access &&
            access.length &&
            permissions &&
            ((permissions[access[0]] && permissions[access[0]][access[1]]) || permissions.all)) ||
          !access ? (
            <Component {...props} />
          ) : (
            <PermissionDenied />
          )
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const Routes = () => {
  const { authUser } = useSelector(({ auth }) => auth);
  const location = useLocation();

  let redirectTo = '/signin';
  if(authUser){
    let adminRole = authUser.info.admin_role
    switch (adminRole) {
      case AdminRoles.Accounting:
        redirectTo = '/loads/documents'; break;
      case AdminRoles.CarrierRep:
        redirectTo = '/loads/loadboard?1'; break;
      case AdminRoles.Dispatcher:
        redirectTo = '/loads/tracking'; break;
      case AdminRoles.GodView:
        redirectTo = '/loads/lanes'; break; // STARTING POINT
      case AdminRoles.OnboardingTeam:
        redirectTo = '/customers/owner_operator'; break;
      case AdminRoles.QAteam:
        redirectTo = '/dashboard'; break;
      case AdminRoles.SAndCTeam:
        redirectTo = '/customers/owner_operator'; break;
      case AdminRoles.LaneManagement:
        redirectTo = '/lanes/interests/all'; break;
      default:
        redirectTo = '/dashboard'; break;
    }
  }

  if (location.pathname === '' || location.pathname === '/') {
    return <Redirect to={redirectTo} />;
  } else if (authUser && location.pathname === '/signin') {
    return <Redirect to={redirectTo} />;
  }

  return (
    <React.Fragment>
    <Suspense fallback={<PageLoader />}>
      <Switch>
        {/* <RestrictedRoute path="/dashboard" component={Dashboard} /> */}
        <RestrictedRoute path={`/dashboard`} component={lazy(() => import('./Dashboard'))} />
        {/* <RestrictedRoute
          path="/dashboard/my-owner-operators"
          component={MyOwnerOperators}
          access="dashboard.my_owner_operators"
        /> */}
        <RestrictedRoute path="/loads/loadboard" component={Loadboard} access="loads.loadboard" />
        <RestrictedRoute path="/customers/owner_operator" component={lazy(() => import('./Users/OwnerOperator'))} access="customers.owner_operator" />
        <RestrictedRoute path="/customers/driver" component={lazy(() => import('./Users/Driver'))} access="customers.driver" />
        <RestrictedRoute path="/customers/company" component={lazy(() => import('./Users/Company'))} access="customers.company" />
        <RestrictedRoute path="/customers/onboarding" component={lazy(() => import('./Users/Onboarding'))} access="customers.onboarding" />
        
        <RestrictedRoute path="/users/admin" component={lazy(() => import('./Users/Admin'))} access="user_management.users" />
        <RestrictedRoute path="/users/roles" component={lazy(() => import('./Users/Roles'))} access="user_management.roles" />
        {/* <RestrictedRoute path="/loads/documents" component={DocumentsUploaded} access="loads.documents" /> */}

        <RestrictedRoute path="/loads/trip-schedular" component={lazy(() => import('./Loads/TripSchedular'))} access="loads.trip_schedular" />
        <RestrictedRoute path="/loads/trips" component={lazy(() => import('./Loads/TripInterests'))} access="loads.trip_interests" key={Math.random()} />
        <RestrictedRoute path="/loads/user-interests" component={lazy(() => import('./Loads/UserInterestsV2'))} access="loads.user_interests" />
        <RestrictedRoute path="/workbook/requests" component={lazy(() => import('./Workbook/Requests'))} access="workbook.requests" /> 
        <RestrictedRoute path="/workbook/bookings" component={lazy(() => import('./Workbook/Bookings'))} access="workbook.bookings" />
        {/* <RestrictedRoute path="/loads/documents" component={LoadsListView} access="loads.documents" /> */}
        <RestrictedRoute path={"/loads/documents"} component={lazy(() => import('./Loads/LoadsDocumentV2/LoadsListView'))} access="loads.documents"/>

        <RestrictedRoute path={"/lanes/interests"} component={lazy(() => import('./Lanes/LaneInterests'))} access="lanes.user_interests"/>
        <RestrictedRoute path={"/lanes/upload"} component={lazy(() => import('./Lanes/UploadLanes'))} access="lanes.upload_lanes"/>
        
        <RestrictedRoute path={"/utils/sms"} component={lazy(() => import('./Utils/sms'))} access="utils.sms" />
        {/*
            User Tracking V1.0
            <RestrictedRoute path="/loads/tracking1" component={LoadsTracking} access="loads.loads_tracking" />
            <Route path="/p/load-tracking1" component={PublicLoadTracking} /> 
        */}

        {/* 
          version 1.1 T&T
          <RestrictedRoute path="/loads/trackingv1/:load_id" component={LoadsDetailView} access="loads.loads_tracking" />
          <RestrictedRoute path="/loads/trackingv1" component={RealTimeTracking} access="loads.loads_tracking" />
          <Route path="/p/load-trackingv1/:load_id_hash" component={PublicLoadTrackingDetailView} /> 
        */}

        {/*Version 1.2 T&T*/}
        <RestrictedRoute path={"/loads/tracking/:load_id"} component={lazy(() => import('./Loads/RealTimeTrackingV2/LoadDetailView'))} />
        <RestrictedRoute path={"/loads/tracking"} component={lazy(() => import('./Loads/RealTimeTrackingV2'))} />

        <RestrictedRoute
          path="/carriers/carrier-network-intelligence"
          component={lazy(() => import('./CarrierNetworkIntelligence/CarriersListingView'))}
          access="carriers.carrier_network"
        />
        <Route path="/p/load-tracking/:load_id_hash" component={lazy(() => import('./Public/PublicLoadTrackingDetailViewV2'))} />

        <RestrictedRoute path="/loads/lanes" component={lazy(() => import('./Loads/Lanes'))} access="loads.lanes" />
        {/* <RestrictedRoute path="/workbook/bookings" component={Bookings} access="workbook.bookings" /> */}
        {/* <RestrictedRoute path="/loads/workbook" component={Workbook} /> */}
        {/* <Route path="/p/zip-code" component={PublicZipCodeParsing} /> */}
        <Route path="/signin" component={lazy(() => import('./Auth/Login'))} />
        {/* <Route path="/signup" component={Register} />
        <Route path="/forgot-password" component={ForgotPasswordPage} /> */}
        <RestrictedRoute
          path="/fleet-management/tb-owner-operators"
          component={lazy(() => import('./FleetManagement/TBOwnerOperators'))}
          access="fleet_management.tb_owneroperators"
        />
        <Route component={lazy(() => import('./Pages/404'))} />
      </Switch>
    </Suspense>
    </React.Fragment>
  );
};

export default Routes;
